import type { TFunction } from '@unifyapps/i18n/client';

// Convert base64 to blob
export function base64ToBlob(base64: string, mimeType: string) {
  const byteCharacters = atob(base64.split(',')[1]);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

// Share base64 image using Web Share API
export async function shareBase64Image(
  base64DataUrl: string,
  t: TFunction,
  shareFile: typeof navigator.share,
) {
  // Extract MIME type from the data URL
  const mimeType = base64DataUrl.match(/data:([^;]+);/)?.[1];
  if (!mimeType) {
    console.error('ShareBlock::Invalid MIME type');
    return;
  }

  // Convert to blob
  const blob = base64ToBlob(base64DataUrl, mimeType);

  // Create a File object from the blob
  const file = new File([blob], 'image.png', { type: mimeType });
  // Check if Web Share API is supported
  await shareFile({
    files: [file],
    title: t('common:OpenShareDialog.ShareImageTitle'),
    text: t('common:OpenShareDialog.ShareImageText'),
    url: base64DataUrl,
  });
}
